export const config = JSON.stringify({
	apiUrl: 'http://localhost:5000',
})
